<template>
  <v-simple-table class="profile-table">
    <thead>
      <tr>
        <th>コンペティション</th>
        <th class="text-center">開催期間</th>
        <th class="text-center">賞金総額</th>
        <th class="text-center">投稿件数</th>
        <th class="text-center">最終順位</th>
      </tr>
    </thead>
    <tbody v-if="competitions.length > 0" class="text-center">
      <tr v-for="(item, index) in competitions" :key="index">
        <td class="text-left">{{item.name}}</td>
        <td v-if="item.isTraining"> - </td>
        <td v-else>{{dateToText(item.startAt)}} - {{dateToText(item.closingAt)}}</td>
        <td>{{item.totalPrize}}</td>
        <td>{{item.numberOfSubmissions}}</td>
        <td v-if="isRanked(item)">{{item | rating}}</td>
        <td v-else> - </td>
      </tr>
    </tbody>
    <tbody v-else>
    <tr>
      <td colspan="5">公開されているコンペティションがありません</td>
    </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
import {mapGetters} from "vuex";
import ApiMixin from "@/ApiMixin";
import ComponentMixin from "@/components/ComponentMixin"

export default {
  components: {},
  mixins: [ApiMixin, ComponentMixin],
  name: "CompetitionSettings",
  props: {
    userId: {
      type: String
    },
  },
  computed: {
    ...mapGetters("user", ["user"]),
    ...mapGetters("competitions", ["list"]),
    competitions() {
      return this.list.filter( (ele)=> ele.showResult === true )
    },
  },
  methods: {
    isRanked (competition) {
      if (competition.latestRank !== null && competition.status === "CLOSED") {
        return true;
      }
      return false;
    },
    onChange (competition, showResult) {
      this.updateCompetitionShowResult(this.userId, competition.id, showResult)
    }
  },
  filters: {
    rating: function(competition) {
      if (
        competition.latestRank !== null &&
        competition.latestRank[0] !== null &&
        competition.status === 'CLOSED'
      ) {
        const rank = Math.ceil(competition.latestRank[0] / competition.latestRank[1] * 100);
        if (rank <= 10) {
          return `Top${rank}%`
        }
        if (rank > 50) {
          return "Over50%"
        }
        return `Top${Math.ceil(rank / 10) * 10}%`
      }
      return '-'
    }
  },
  watch: {
    "userId": {
      handler: function (id) {
        if (id && this.user.id) {
          this.loadCompetitions(this.userId)
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped lang="sass">
.profile-table
  margin: 0 16px
</style>
